export const URL = "/api"

const API = {
    "BASE": URL,
    // AUTHENTICATION
    "LOGIN": URL + "/Authentication/Login",
    "REGISTER": URL + "/Authentication/Register",
    "REFRESH": URL + "/Authentication/Refresh",
    // LOG
    "LOG_GETALL": URL + "/Log/GetAll",
    "LOG_GET": URL + "/Log/Get",
    "LOG_DELETE": URL + "/Log/Delete",
}

export default API
